import { LoadableAfterPaint } from '@confluence/loadable';

export const LegacyMacroRenderer = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LegacyMacroRenderer" */ '../src/LegacyMacroRendererQuery.tsx'
			)
		).LegacyMacroRendererQuery,
});

export const DebouncedLegacyMacroRenderer = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-DebouncedLegacyMacroRenderer" */ '../src/LegacyMacroRendererQuery.tsx'
			)
		).DebouncedLegacyMacroRendererQuery,
});

export { LegacyMacroRendererQueryComponent } from '../src/LegacyMacroRendererQuery.tsx';
